import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./Redux/Store";
import { AliveScope } from "react-activation";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
       <AliveScope>
  <Provider store={store}>
    <BrowserRouter future={{
           v7_relativeSplatPath: true,
           v7_startTransition: true,
         }}>
      <App />
    </BrowserRouter>
  </Provider>
  </AliveScope>
)